import { createSlice } from "@reduxjs/toolkit";

export const surveyInfoSlice = createSlice({
  name: "surveyInfo",
  initialState: null,
  reducers: {
    setSurveyInfo: (state, action) => {
      return action.payload;
    },
  },
});

export const { setSurveyInfo } = surveyInfoSlice.actions;

export default surveyInfoSlice.reducer;
